export default __webpack_public_path__ + "static/media/DK.99cbc127.svg";